import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BooksPage from '../layout';

function BooksRoute() {
	return (
		<Routes>
			<Route path="*" element={<BooksPage />} />
		</Routes>
	);
}

export default BooksRoute;
